module.exports = __webpack_public_path__ + "img/dovista.a9ada3da.png";